module.exports = __webpack_public_path__ + "media/zoho/zoho_faq2-50525ba3.png";